export const callFetch = async (url, options = {}) => {
  const result = await fetch(url, {
    credentials: 'include',
    ...options,
  });

  const resultJson = result.json();

  return resultJson;
};
